export const GENRES = [
  "Pop",
  "Hip-Hop",
  "Rock",
  "Electronic",
  "Jazz",
  "Classical",
  "R&B",
  "Lo-Fi",
  "Ambient",
  "Country",
] as const;

export const MOBILE_GENRES = [
  "Pop",
  "Hip-hop",
  "R&B",
  "Rock",
  "Electronic",
  "Jazz",
  "Classical",
  "Lo-fi",
  "Country",
  "Ambient",
] as const;

export const STYLES = [
  "Energetic",
  "Chill",
  "Dark",
  "Uplifting",
  "Melancholic",
  "Cinematic",
  "Groovy",
  "Aggressive",
] as const;

export const MOBILE_STYLES = [
  "Energetic",
  "Chill",
  "Dark",
  "Groovy",
  "Melancholic",
  "Uplifting",
  "Aggressive",
  "Cinematic",
] as const;

export const TEMPOS = [
  "Very Slow",
  "Slow",
  "Medium",
  "Fast",
  "Very Fast",
] as const;

export const MOBILE_TEMPOS = [
  "Very slow",
  "Slow",
  "Medium",
  "Fast",
  "Very fast",
] as const;

export const KEY_SIGNATURES = [
  "C Major",
  "G Major",
  "D Major",
  "A Major",
  "A Minor",
  "D Minor",
  "G Minor",
  "C Minor",
] as const;

export const MOBILE_KEY_SIGNATURES = [
  "C major",
  "G major",
  "D major",
  "A major",
  "A minor",
  "D minor",
  "G minor",
  "C minor",
] as const;

export const INSTRUMENTS = [
  "Guitar",
  "Piano",
  "Drums",
  "Synth",
  "Bass",
  "Strings",
  "Brass",
  "Violin",
] as const;

export const VOCAL_STYLES = [
  "Male",
  "Female",
  "Rap",
  "Falsetto",
  "Breathy",
  "Raw",
] as const;

export const VOCAL_MODES = [
  "Lead Vocals",
  "A Cappella",
  "Two Singers Harmonizing",
  "Choir",
] as const;

export const MOBILE_VOCAL_MODES = [
  "Lead vocals",
  "A cappella",
  "Two singers harmonizing",
  "Choir",
] as const;

export const VOCAL_MODE_INSTRUMENTAL = "Instrumental Only" as const;
export const VOCAL_MODE_A_CAPPELLA = "A Cappella" as const;

export const MUSIC_PRESETS = [
  {
    name: "Upbeat pop",
    descriptor: "Pop, energetic, fast, piano, lead vocals, female, english",
  },
  { name: "Lo-fi chill", descriptor: "Lo-fi, chill, slow, guitar, 85 BPM" },
  {
    name: "Orchestral epic",
    descriptor: "Classical cinematic, medium, strings, brass, violin",
  },
  {
    name: "Hip-hop dark",
    descriptor: "Hip-hop, dark, aggressive, drums, bass, rap, male",
  },
  {
    name: "K-pop energetic",
    descriptor: "K-pop, energetic, fast, synth, two singers, Korean",
  },
] as const;

/** Default generation length for unauthenticated users (1 minute 40 seconds). */
export const UNAUTH_DEFAULT_DURATION_MS = 100_000;

/** Max preview playback for unauthenticated users (full song still generated). */
export const UNAUTH_PLAYBACK_LIMIT_MS = 20_000;

/** Trigger preview limit this many seconds before the hard cap (handles media time stall). */
export const PREVIEW_LIMIT_EPSILON_SEC = 1;

export const DURATION_PRESETS = [
  { label: "0:30", seconds: 30 },
  { label: "1:00", seconds: 60 },
  { label: "1:30", seconds: 90 },
  { label: "2:00", seconds: 120 },
  { label: "3:00", seconds: 180 },
  { label: "5:00", seconds: 300 },
] as const;

export const LANGUAGES = [
  "English",
  "Spanish",
  "French",
  "Portuguese",
  "Italian",
  "German",
  "Japanese",
  "Korean",
] as const;

export const GENRE_BPM_DEFAULTS: Record<string, number> = {
  Pop: 110,
  "Hip-Hop": 85,
  Rock: 130,
  Electronic: 128,
  Jazz: 110,
  Classical: 80,
  "R&B": 85,
  "Lo-Fi": 75,
  Ambient: 60,
  Country: 100,
};

export const GENRE_BPM_HINTS: Record<string, string> = {
  Pop: "Pop genre tempo usually ranges from 100 to 130 BPM",
  "Hip-Hop": "Hip-Hop genre tempo usually ranges from 60 to 100 BPM",
  Rock: "Rock genre tempo usually ranges from 100 to 160 BPM",
  Electronic: "Electronic genre tempo usually ranges from 120 to 140 BPM",
  Jazz: "Jazz genre tempo usually ranges from 90 to 140 BPM",
  Classical: "Classical genre tempo usually ranges from 60 to 120 BPM",
  "R&B": "R&B genre tempo usually ranges from 70 to 110 BPM",
  "Lo-Fi": "Lo-Fi genre tempo usually ranges from 60 to 90 BPM",
  Ambient: "Ambient genre tempo usually ranges from 40 to 80 BPM",
  Country: "Country genre tempo usually ranges from 80 to 120 BPM",
};

export const DEFAULT_MUSIC_LENGTH_MS = 100_000; // 1 minute 40 seconds
export const SKIP_SECONDS = 10; // 10 seconds
export const MAX_DURATION_MINUTES = 5; // 5 minutes


export const domainUrl = () => {
  const configuredDomainUrl = import.meta.env.VITE_DOMAIN_URL;
  if (configuredDomainUrl) {
    return configuredDomainUrl;
  }
};





console.log("app current-environment::", `${import.meta.env.VITE_ENVIRONMENT}`);